import { state } from '../state';
import Synchronizer, { type SynchronizerOptions } from './Synchronizer';
import type { ISynchronizerEventHandler } from '../../types';

/**
 * Create a new synchronizer instance from Synchronizer class
 * @param synchronizerId - The id of the synchronizer.
 * @param eventName - The name of the event that will be emitted by the
 * synchronizer.
 * @param eventHandler - The event handler that will be
 * called when the event is emitted.
 * @param options - Options for the synchronizer.
 * @returns A reference to the synchronizer.
 */
function createSynchronizer(
  synchronizerId: string,
  eventName: string,
  eventHandler: ISynchronizerEventHandler,
  options?: SynchronizerOptions
): Synchronizer {
  const synchronizerWithSameIdExists = state.synchronizers.some(
    (sync) => sync.id === synchronizerId
  );

  if (synchronizerWithSameIdExists) {
    throw new Error(`Synchronizer with id '${synchronizerId}' already exists.`);
  }

  // Create
  const synchronizer = new Synchronizer(
    synchronizerId,
    eventName,
    eventHandler,
    options
  );

  // Update state
  state.synchronizers.push(synchronizer);

  // Return reference
  return synchronizer;
}

export default createSynchronizer;
